import React from "react";
import Head from "../head/Index";
import SectionUniverseSigmobi from "../sections/section-universe-sigmobi/Index"
import SectionNewOpportunities from "../sections/section-new-opportunities/Index"
import SectionBenefities from "../sections/section-benefities/Index"
import SectionSocialNetwork from "../sections/section-social-network/Index"
import SectionBalance from "../sections/section-balance/Index"
import './../../assets/js/script_head.js';

class Main extends React.Component {
  render() {
    return (
      <div>
        <Head/>
        <body className="home page-template page-template-elementor_canvas page page-id-57 elementor-default elementor-template-canvas elementor-kit-12 elementor-page elementor-page-57">
          <div
            data-elementor-type="wp-page"
            data-elementor-id="57"
            className="elementor elementor-57"
          >
            <SectionUniverseSigmobi/>
            <SectionNewOpportunities/>
            <SectionBenefities />
            <SectionSocialNetwork />
            <SectionBalance />

          </div>

          <script src="./../../assets/js/script_body.js" type="text/javascript"></script>
          <script
            src="./../../assets/wp-includes/js/dist/hooks.min.js?ver=4d63a3d491d11ffd8ac6"
            id="wp-hooks-js"
          ></script>
          <script
            src="./../../assets/wp-includes/js/dist/i18n.min.js?ver=5e580eb46a90c2b997e6"
            id="wp-i18n-js"
          ></script>

          <script
            src="./../../assets/wp-content/plugins/contact-form-7/includes/swv/js/index.js?ver=6.0.1"
            id="swv-js"
          ></script>

          <script
            src="./../../assets/wp-content/plugins/contact-form-7/includes/js/index.js?ver=6.0.1"
            id="contact-form-7-js"
          ></script>
          <script
            src="./../../assets/wp-content/themes/hello-elementor/assets/js/hello-frontend.min.js?ver=3.1.1"
            id="hello-theme-frontend-js"
          ></script>
          <script
            src="./../../assets/wp-content/plugins/elementor/assets/js/webpack.runtime.min.js?ver=3.25.10"
            id="elementor-webpack-runtime-js"
          ></script>
          <script
            src="./../../assets/wp-includes/js/jquery/jquery.min.js?ver=3.7.1"
            id="jquery-core-js"
          ></script>
          <script
            src="./../../assets/wp-includes/js/jquery/jquery-migrate.min.js?ver=3.4.1"
            id="jquery-migrate-js"
          ></script>
          <script
            src="./../../assets/wp-content/plugins/elementor/assets/js/frontend-modules.min.js?ver=3.25.10"
            id="elementor-frontend-modules-js"
          ></script>
          <script
            src="./../../assets/wp-includes/js/jquery/ui/core.min.js?ver=1.13.3"
            id="jquery-ui-core-js"
          ></script>

          <script
            src="./../../assets/wp-content/plugins/elementor/assets/js/frontend.min.js?ver=3.25.10"
            id="elementor-frontend-js"
          ></script>
        </body>
      </div>
    );
  }
}

export default Main;
